module.exports = __webpack_public_path__ + "static/media/settings.9d3ee78e.jpg";